// @ts-nocheck
import { MODULE_ACL, USER_ROLES } from "./constant";
import { isAclModuleOptionsRelevant } from "./aclModuleOptionsAccess";
import { parseModuleOperations } from "./voicePlanAcl";

export const USERS_ACL_MODULE = MODULE_ACL.USERS;
export const EMAIL_VERIFICATION_ACL_OPTION = "email_verification";
export const DEFAULT_USERS_EDIT_OPTIONS = [];

function isSuperAdminRole(userRole, isSuperAdmin) {
  return isSuperAdmin || userRole === USER_ROLES.SUPERADMIN;
}

export function getUsersAclEntry(moduleOperations) {
  const ops = parseModuleOperations(moduleOperations);
  return ops[USERS_ACL_MODULE] || null;
}

export function normalizeUsersEmailVerificationOptions(options) {
  if (!Array.isArray(options)) return [];
  return [
    ...new Set(
      options
        .map((o) => String(o).trim())
        .filter((o) => o === EMAIL_VERIFICATION_ACL_OPTION)
    ),
  ];
}

export function aclRecordRequiresEmailVerification(moduleOperations) {
  const entry = getUsersAclEntry(moduleOperations);
  if (!entry?.edit && !entry?.add) {
    return false;
  }
  if (!Array.isArray(entry.edit_options)) {
    return false;
  }
  return normalizeUsersEmailVerificationOptions(entry.edit_options).includes(
    EMAIL_VERIFICATION_ACL_OPTION
  );
}

export function requiresEmailVerification(
  moduleOperations,
  { userRole = null, isSuperAdmin = false } = {}
) {
  if (isSuperAdminRole(userRole, isSuperAdmin)) {
    return false;
  }
  return aclRecordRequiresEmailVerification(moduleOperations);
}

export function isUsersEmailVerificationAclConfigured(moduleEntry) {
  if (!moduleEntry?.edit && !moduleEntry?.add) return false;
  return Array.isArray(moduleEntry.edit_options);
}

export function getParentGrantableUsersEmailVerification(
  moduleOperations,
  isSuperAdmin
) {
  if (isSuperAdmin) {
    return { canGrantEmailVerification: true };
  }
  const entry = getUsersAclEntry(moduleOperations);
  if (!entry?.add && !entry?.edit) {
    return { canGrantEmailVerification: false };
  }
  if (!Array.isArray(entry?.edit_options)) {
    return { canGrantEmailVerification: true };
  }
  return {
    canGrantEmailVerification: normalizeUsersEmailVerificationOptions(
      entry.edit_options
    ).includes(EMAIL_VERIFICATION_ACL_OPTION),
  };
}

export function normalizeUsersEmailVerificationAclForSave(
  { edit_options = [] } = {},
  parentGrantable = null
) {
  let options = normalizeUsersEmailVerificationOptions(edit_options);
  if (parentGrantable && !parentGrantable.canGrantEmailVerification) {
    options = [];
  }
  return { edit_options: options };
}

export function formatUsersEmailVerificationAclLabel(moduleEntry) {
  if (!isAclModuleOptionsRelevant(moduleEntry)) return "—";
  const options = normalizeUsersEmailVerificationOptions(moduleEntry.edit_options);
  if (!options.includes(EMAIL_VERIFICATION_ACL_OPTION)) return "—";
  return "Verify required";
}

export function getCreatorModuleOperations(creatorUser) {
  if (!creatorUser) return null;
  const raw =
    creatorUser.module_operations ?? creatorUser.acl_settings?.module_operations;
  if (!raw) return null;
  return typeof raw === "string" ? parseModuleOperations(raw) : raw;
}

/** OTP on user/agent create-edit forms is driven by the logged-in creator's Users ACL, not the child's ACL. */
export function creatorRequiresEmailVerificationOnUserForms(
  creatorUser,
  { isSuperAdmin = false, userRole = null } = {}
) {
  if (isSuperAdminRole(userRole, isSuperAdmin)) {
    return false;
  }
  const ops = getCreatorModuleOperations(creatorUser);
  if (!ops) {
    return false;
  }
  return aclRecordRequiresEmailVerification(ops);
}

export function assignedAclRequiresEmailVerification(
  aclSettingList,
  aclId,
  { isSuperAdmin = false } = {}
) {
  if (isSuperAdmin || !aclId) {
    return false;
  }
  const acl = (aclSettingList || []).find(
    (item) => String(item.id) === String(aclId)
  );
  if (!acl?.module_operations) {
    return false;
  }
  const ops =
    typeof acl.module_operations === "string"
      ? parseModuleOperations(acl.module_operations)
      : acl.module_operations;
  return aclRecordRequiresEmailVerification(ops);
}
